import React from 'react';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * Quick hover submenu for citing evidence to report fragments
 * Shows suggested passages (first 3) + "Select passage..." option
 */
export default function CiteQuickMenu({
                                          open,
                                          anchorEl,
                                          fragmentMarks,
                                          selectedFragmentUid,
                                          selectedFragmentMark,
                                          onCiteToFragment,
                                          onOpenSelectPassage,
                                          onClose,
                                          submenuModifiers,
                                      }) {
    const truncateText = (text, maxLength = 40) => {
        if (!text) return '(no text)';
        return text.length > maxLength ? text.slice(0, maxLength - 3) + '…' : text;
    };

    // Get suggested passages: selected + first 2 others (total 3)
    const getSuggestedPassages = () => {
        const suggestions = [];

        // Add selected fragment first if exists
        if (selectedFragmentUid && selectedFragmentMark) {
            suggestions.push({
                uid: selectedFragmentUid,
                text: selectedFragmentMark.text,
                isSelected: true
            });
        }

        // Add other fragments (up to 2 more to make total of 3)
        const otherFragments = (fragmentMarks || [])
            .filter(({uid}) => uid !== selectedFragmentUid)
            .slice(0, selectedFragmentUid ? 2 : 3);

        suggestions.push(...otherFragments.map(f => ({...f, isSelected: false})));

        return suggestions;
    };

    const suggestedPassages = getSuggestedPassages();
    const hasFragments = suggestedPassages.length > 0;

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="right-start"
            modifiers={submenuModifiers}
            sx={{zIndex: 10000}}
        >
            <Paper elevation={4} className="evidence-allow-select">
                <MenuList autoFocusItem={false} disableListWrap dense>
                    {!hasFragments && (
                        <MenuItem disabled>No report fragments found</MenuItem>
                    )}

                    {hasFragments && (
                        <>
                            <ListSubheader disableSticky sx={{lineHeight: '28px', fontSize: '0.75rem'}}>
                                Suggested passages
                            </ListSubheader>

                            {suggestedPassages.map(({uid, text, isSelected}) => (
                                <MenuItem
                                    key={uid}
                                    onClick={() => {
                                        onCiteToFragment(uid);
                                        onClose();
                                    }}
                                    sx={{py: 1}}
                                >
                                    <ListItemIcon sx={{minWidth: 32}}>
                                        <FormatQuoteIcon
                                            fontSize="small"
                                            color={isSelected ? "primary" : "inherit"}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={truncateText(text)}/>
                                </MenuItem>
                            ))}

                            <Divider sx={{my: 0.5}}/>

                            {/* Select passage option */}
                            <MenuItem
                                onClick={() => {
                                    onOpenSelectPassage();
                                    onClose();
                                }}
                                sx={{py: 1}}
                            >
                                <ListItemIcon sx={{minWidth: 32}}>
                                    <MoreHorizIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="Select passage..."
                                    slotProps={{primary: {sx: {fontStyle: 'italic'}}}}
                                />
                            </MenuItem>
                        </>
                    )}
                </MenuList>
            </Paper>
        </Popper>
    );
}
